const MONGO_ID_REG = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i;

export default function isMongoId(str: any) {
    if (!str) return false;
    if (typeof str !== 'string') return false;
    return MONGO_ID_REG.test(str);
}
